import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { CurrencyProvider } from "./context/CurrencyContext";
import SupportChat from "./components/SupportChat";
import BacklogReviewPopup from "./components/BacklogReviewPopup";
import AppUpdateNotice from "./components/AppUpdateNotice";
import PageErrorBoundary from "./components/PageErrorBoundary";

// Pages
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import ProjectsPage from "./pages/ProjectsPage";
import ProjectDetailPage from "./pages/ProjectDetailPage";
import TasksPage from "./pages/TasksPage";
import TaskDetailPage from "./pages/TaskDetailPage";
import UsersPage from "./pages/UsersPage";
import ArtistsPage from "./pages/ArtistsPage";
import StaffPage from "./pages/StaffPage";
import OrgStructurePage from "./pages/OrgStructurePage";
import BonusMatrixPage from "./pages/BonusMatrixPage";
import TeamExpensesPage from "./pages/TeamExpensesPage";
import OtherExpensesPage from "./pages/OtherExpensesPage";
import PNLForecastPage from "./pages/PNLForecastPage";
import StaffPnlDetailPage from "./pages/StaffPnlDetailPage";
import ArtistPnlPage from "./pages/ArtistPnlPage";
import PaymentsPage from "./pages/PaymentsPage";
import NotificationsPage from "./pages/NotificationsPage";
import SalesDashboardPage from "./pages/SalesDashboardPage";
import SalesPnlPageNew from "./pages/SalesPnlPageNew";
import SalesProjectEditPage from "./pages/SalesProjectEditPage";
import ProfilePage from "./pages/ProfilePage";
import TeamCalendarPage from "./pages/TeamCalendarPage";
import MySalaryPage from "./pages/MySalaryPage";
import MyTasksPage from "./pages/MyTasksPage";
import MyExpensesPage from "./pages/MyExpensesPage";
import CrmIncomePage from "./pages/CrmIncomePage";
import CrmPnlPage from "./pages/CrmPnlPage";
import CrmDashboardPage from "./pages/CrmDashboardPage";
import TrpSalesPage from "./pages/TrpSalesPage";
import PartnerProjectPage from "./pages/PartnerProjectPage";
import PartnerTasksPage from "./pages/PartnerTasksPage";
import PartnerArtistsPage from "./pages/PartnerArtistsPage";
import GeneralPnlPage from "./pages/GeneralPnlPage";
import IncomePage from "./pages/IncomePage";
import RoadmapPage from "./pages/RoadmapPage";
import ArtistDashboardPage from "./pages/ArtistDashboardPage";
import ArtistContractPage from "./pages/ArtistContractPage";
import ArtistTasksPage from "./pages/ArtistTasksPage";
import ArtDirectorReviewPage from "./pages/ArtDirectorReviewPage";
import ServiceRatesPage from "./pages/ServiceRatesPage";
import ServicesManagementPage from "./pages/ServicesManagementPage";
import TimelineSettingsPage from "./pages/TimelineSettingsPage";
import StatusSettingsPage from "./pages/StatusSettingsPage";
import FopSettingsPage from "./pages/FopSettingsPage";
import SupportTariffsPage from "./pages/SupportTariffsPage";
import PaymentPenaltySettingsPage from "./pages/PaymentPenaltySettingsPage";
import InvoiceDescriptionSettingsPage from "./pages/InvoiceDescriptionSettingsPage";
import LoadedCostSettingsPage from "./pages/LoadedCostSettingsPage";
import OrphanedProjectsPage from "./pages/OrphanedProjectsPage";
import TrpPaymentDetailPage from "./pages/TrpPaymentDetailPage";
import ClientPortalPage from "./pages/ClientPortalPage";
import MyPaymentSchedulePage from "./pages/MyPaymentSchedulePage";
import ClientPaymentsView from "./components/client-portal/ClientPaymentsView";
import ClientTasksView from "./components/client-portal/ClientTasksView";
import ClientRequestsPage from "./pages/ClientRequestsPage";
import ClientRequestDetailPage from "./pages/ClientRequestDetailPage";
import ClientMyRequestsPage from "./pages/ClientMyRequestsPage";
import UnifiedProjectsPage from "./pages/UnifiedProjectsPage";
import ClientsPage from "./pages/ClientsPage";
import PortfolioPage from "./pages/PortfolioPage";
import PaymentDetailPage from "./pages/PaymentDetailPage";
import ArtistPaymentDetailPage from "./pages/ArtistPaymentDetailPage";
import TaskPaymentDetailPage from "./pages/TaskPaymentDetailPage";
import DashboardV2Page from "./pages/DashboardV2Page";
import TeamUtilizationPage from "./pages/TeamUtilizationPage";
import CashflowForecastPage from "./pages/CashflowForecastPage";
import ClientProjectsPage from "./pages/ClientProjectsPage";
import ClientProjectDetailPage from "./pages/ClientProjectDetailPage";
import PartnerRequestsPage from "./pages/PartnerRequestsPage";
import NotificationSettingsPage from "./pages/NotificationSettingsPage";
import WaitingManagementPage from "./pages/WaitingManagementPage";
import BankTransactionsPage from "./pages/BankTransactionsPage";
import IntegrationSettingsPage from "./pages/IntegrationSettingsPage";
import WorksectionUsersPage from "./pages/WorksectionUsersPage";
import AIQualityControlPage from "./pages/AIQualityControlPage";
import CandidatesPage from "./pages/CandidatesPage";
import CandidateDetailPage from "./pages/CandidateDetailPage";
import ProjectTimelinePage from "./pages/ProjectTimelinePage";
import SupportChatsPage from "./pages/SupportChatsPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import AdminSecurityPage from "./pages/AdminSecurityPage";
import SetupAccountPage from "./pages/SetupAccountPage";
import SandboxPage from "./pages/SandboxPage";
import PMBonusesPage from "./pages/PMBonusesPage";
import DevBacklogPage from "./pages/DevBacklogPage";
import ChangelogPage from "./pages/ChangelogPage";
import SalesLeadsPage from "./pages/SalesLeadsPage";
import SalesProposalsPage from "./pages/SalesProposalsPage";
import SocialLeadsPage from "./pages/SocialLeadsPage";
import WepsterSettingsPage from "./pages/WepsterSettingsPage";
import TelegramInboxPage from "./pages/TelegramInboxPage";
import TelegramSettingsPage from "./pages/TelegramSettingsPage";
import MarketingAnalyticsPage from "./pages/MarketingAnalyticsPage";
import AdsQualityPage from "./pages/AdsQualityPage";
import MarketingCampaignReportPage from "./pages/MarketingCampaignReportPage";
import MarketingPeoplePage from "./pages/MarketingPeoplePage";
import MarketingPersonProfilePage from "./pages/MarketingPersonProfilePage";
import MarketingSalesPage from "./pages/MarketingSalesPage";
import MarketingLandingsPage from "./pages/MarketingLandingsPage";
import MarketingChatsPage from "./pages/MarketingChatsPage";
import ErrorLogsPage from "./pages/ErrorLogsPage";
import SetupFlowsAdminPage from "./pages/SetupFlowsAdminPage";
import SupportKbPage from "./pages/SupportKbPage";
import SupportProductsPage from "./pages/SupportProductsPage";
import SupportProductDetailPage from "./pages/SupportProductDetailPage";
import SupportAccessPage from "./pages/SupportAccessPage";
import MyFeedbackPage from "./pages/MyFeedbackPage";
import FinanceDocumentsPage from "./pages/FinanceDocumentsPage";
import RoleplayPage from "./pages/RoleplayPage";
import CallReviewsPage from "./pages/CallReviewsPage";
import PartnerRevenueCalculatorPage from "./pages/PartnerRevenueCalculatorPage";

// Layout
import SidebarLayout from "./components/layout/SidebarLayout";

const ProtectedRoute = ({ children, allowedRoles, accessCheckUrl, allowFlag }) => {
  const { user, loading } = useAuth();
  // accessCheckUrl: optional API endpoint that returns {can_view: bool}. When
  // provided, access is granted if EITHER role matches OR the endpoint says
  // can_view: true. Used for /marketing-analytics where we want role-based
  // gating PLUS an email allowlist managed in integration_settings.
  const [extraAccess, setExtraAccess] = React.useState(accessCheckUrl ? null : { can_view: false });
  const [extraLoading, setExtraLoading] = React.useState(!!accessCheckUrl);

  // React reuses this same ProtectedRoute instance across route changes (same
  // component type at the same tree position), so extraAccess/extraLoading carry
  // over from the PREVIOUS route. When navigating SPA-style from a route without
  // accessCheckUrl (e.g. a partner clicking Roleplay from /trp/sales) to one with
  // it, the first render would otherwise see a stale extraAccess={can_view:false}
  // + extraLoading=false and redirect away BEFORE the access fetch runs. Reset the
  // gate state during render when accessCheckUrl changes (the React "adjust state
  // on prop change" pattern) so the first render shows the spinner instead.
  // Marker: protected-route-accesscheck-reset-v1
  const [trackedCheckUrl, setTrackedCheckUrl] = React.useState(accessCheckUrl);
  if (trackedCheckUrl !== accessCheckUrl) {
    setTrackedCheckUrl(accessCheckUrl);
    setExtraAccess(accessCheckUrl ? null : { can_view: false });
    setExtraLoading(!!accessCheckUrl);
  }

  React.useEffect(() => {
    if (!accessCheckUrl) return;
    // CRITICAL: when there's no user (logged out / expired token), clear the
    // access-check loading flag so the `if (!user) → redirect to /login` path
    // below can fire. Without this, extraLoading stays true forever and the
    // route renders an infinite spinner — the "black screen" agency users hit
    // when their token expired and they landed on /marketing-analytics (the
    // only routes that use accessCheckUrl). Marker: protected-route-no-user-fix-v1
    if (!user) { setExtraLoading(false); return; }
    let cancelled = false;
    import("./lib/api").then(({ default: api }) => {
      api.get(accessCheckUrl).then((r) => {
        if (!cancelled) setExtraAccess(r.data || { can_view: false });
      }).catch(() => {
        if (!cancelled) setExtraAccess({ can_view: false });
      }).finally(() => {
        if (!cancelled) setExtraLoading(false);
      });
    });
    return () => { cancelled = true; };
  }, [accessCheckUrl, user]);

  if (loading || extraLoading) {
    return (
      <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-orange-500"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // allowFlag: a per-person flag on the user (e.g. portfolio_access) that
  // opens the route on top of the role list.
  const roleAllowed = !allowedRoles || allowedRoles.includes(user.role) || (!!allowFlag && !!user[allowFlag]);
  const allowlistAllowed = !!extraAccess?.can_view;
  if (!roleAllowed && !allowlistAllowed) {
    // Send the user to THEIR home, not a hardcoded /my-payments — so an
    // isolated roleplay_tester bounced off a disallowed page lands back on
    // /roleplay (their only page) instead of an empty payments screen.
    return <Navigate to={getDefaultRoute(user)} replace />;
  }

  return <SidebarLayout><PageErrorBoundary>{children}</PageErrorBoundary></SidebarLayout>;
};

// Read-only "view as client" preview. An internal user opens
// /client-preview?as_client=<id> to see the EXACT client cabinet. Renders the
// real ClientPortalPage inside SidebarLayout with the CLIENT role/name so the
// whole chrome is identical; the backend serves that client's data read-only.
const CLIENT_PREVIEW_ROLES = ["admin", "sales", "sales_director", "pm_lead", "pm", "crm_manager", "finance"];
const ClientCabinetPreview = () => {
  const { user, loading } = useAuth();
  const [clientName, setClientName] = React.useState(null);
  React.useEffect(() => {
    const cid = new URLSearchParams(window.location.search).get("as_client");
    if (!cid) return;
    import("./lib/api").then(({ default: api }) =>
      api
        .get(`/admin/client-brief?client_id=${encodeURIComponent(cid)}`)
        .then((r) => setClientName(r.data?.name))
        .catch(() => {}),
    );
  }, []);
  if (loading) {
    return (
      <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-orange-500"></div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!CLIENT_PREVIEW_ROLES.includes(user.role)) return <Navigate to="/my-payments" replace />;
  return (
    <SidebarLayout roleOverride="client" nameOverride={clientName}>
      <PageErrorBoundary>
        <ClientPortalPage />
      </PageErrorBoundary>
    </SidebarLayout>
  );
};

// TRP Redirect wrapper - all users go to /trp/sales (old TrpProjectsPage removed from menu)
const TrpRedirectWrapper = () => {
  return <Navigate to="/trp/sales" replace />;
};

// Dashboard switcher: admin sees the new owner overview (V2), other roles see the
// legacy operational dashboard. Old admin view still reachable via /dashboard-legacy.
const DashboardSwitcher = () => {
  const { user } = useAuth();
  return user?.role === "admin" ? <DashboardV2Page /> : <DashboardPage />;
};

// Helper to get default route based on user role
const getDefaultRoute = (userOrRole) => {
  // Accept either a role string (legacy callers) or the full user object.
  // When a user object with `default_landing_path` arrives — backend already
  // resolved the right landing route (e.g. marketing-agency users with
  // allowlist access land on /marketing-analytics, not /my-payments).
  // Marker: default-landing-path-v1
  if (userOrRole && typeof userOrRole === "object") {
    if (userOrRole.default_landing_path) return userOrRole.default_landing_path;
    userOrRole = userOrRole.role;
  }
  const role = userOrRole;
  if (role === "admin" || role === "pm_lead" || role === "pm" || role === "crm_manager" || role === "finance") return "/dashboard";
  if (role === "sales_director") return "/sales";
  if (role === "partner") return "/trp/sales";
  if (role === "artist") return "/artist-dashboard";
  if (role === "client") return "/client-portal";
  if (role === "roleplay_tester") return "/roleplay"; // Isolated sales-trainer testers
  if (role === "team") return "/my-payments"; // Team role only has access to payments
  return "/my-payments"; // All other users default to payments page
}

import usePageTitle from "./hooks/usePageTitle";

function AppRoutes() {
  const { user, loading } = useAuth();
  usePageTitle(); // Set page titles

  if (loading) {
    return (
      <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-orange-500"></div>
      </div>
    );
  }

  const defaultRoute = user ? getDefaultRoute(user) : "/";

  return (
    <Routes>
      {/* Landing page for non-authenticated users */}
      <Route path="/" element={user ? <Navigate to={defaultRoute} /> : <LandingPage />} />
      <Route path="/login" element={user ? <Navigate to={defaultRoute} /> : <LoginPage />} />
      <Route path="/register" element={user ? <Navigate to={defaultRoute} /> : <RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ForgotPasswordPage />} />
      <Route path="/setup-account" element={<SetupAccountPage />} />
      
      {/* Admin, PM Lead and PM pages */}
      <Route path="/dashboard" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "pm", "crm_manager", "art_director", "finance"]}><DashboardSwitcher /></ProtectedRoute>} />
      <Route path="/dashboard-legacy" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "pm", "crm_manager", "art_director", "finance"]}><DashboardPage /></ProtectedRoute>} />
      {/* Owner Dashboard page removed 2026-10-29 — /dashboard and /general-pnl cover it; old links land on /dashboard. */}
      <Route path="/owner-dashboard" element={<Navigate to="/dashboard" replace />} />
      <Route path="/cashflow" element={<ProtectedRoute allowedRoles={["admin", "sales", "sales_director", "pm_lead", "crm_manager", "finance"]}><CashflowForecastPage /></ProtectedRoute>} />
      <Route path="/finance/documents" element={<ProtectedRoute allowedRoles={["admin", "finance", "pm_lead", "sales_director"]}><FinanceDocumentsPage /></ProtectedRoute>} />
      <Route path="/bank-transactions" element={<ProtectedRoute allowedRoles={["admin", "sales_director", "pm_lead", "finance"]}><BankTransactionsPage /></ProtectedRoute>} />
      <Route path="/projects" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "pm", "art_director", "crm_manager"]}><ProjectsPage /></ProtectedRoute>} />
      <Route path="/projects/:id" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "pm", "art_director", "crm_manager"]}><ProjectDetailPage /></ProtectedRoute>} />
      <Route path="/unified-projects" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "pm", "sales", "art_director", "crm_manager", "sales_director"]}><UnifiedProjectsPage /></ProtectedRoute>} />
      <Route path="/unified-projects/:id" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "pm", "sales", "art_director", "crm_manager", "sales_director"]}><SalesProjectEditPage /></ProtectedRoute>} />
      <Route path="/clients" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "pm", "sales", "sales_director", "crm_manager"]}><ClientsPage /></ProtectedRoute>} />
      {/* 3D twins are the product; studio work (sites, renders) gets its own URL,
          deliberately not a tab of the twins page. */}
      <Route path="/portfolio" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "pm", "art_director", "sales", "sales_director", "crm_manager"]} allowFlag="portfolio_access"><PortfolioPage section="twins" /></ProtectedRoute>} />
      {/* Brands are routes, not JS tabs — the menu lands you on your own brand
          instead of making you re-click a filter on every visit. */}
      <Route path="/portfolio/vexos" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "pm", "art_director", "sales", "sales_director", "crm_manager"]} allowFlag="portfolio_access"><PortfolioPage section="twins" brand="trp" /></ProtectedRoute>} />
      <Route path="/portfolio/smartorange" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "pm", "art_director", "sales", "sales_director", "crm_manager"]} allowFlag="portfolio_access"><PortfolioPage section="twins" brand="smartorange" /></ProtectedRoute>} />
      <Route path="/portfolio/studio" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "pm", "art_director", "sales", "sales_director", "crm_manager"]} allowFlag="portfolio_access"><PortfolioPage section="studio" /></ProtectedRoute>} />
      <Route path="/tasks" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "pm", "art_director", "crm_manager"]}><TasksPage /></ProtectedRoute>} />
      <Route path="/tasks/:id" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "pm", "art_director", "partner", "crm_manager", "finance"]}><TaskDetailPage /></ProtectedRoute>} />
      <Route path="/art-director/review" element={<ProtectedRoute allowedRoles={["admin", "art_director", "pm", "pm_lead"]}><ArtDirectorReviewPage /></ProtectedRoute>} />
      <Route path="/users" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "finance"]}><UsersPage /></ProtectedRoute>} />
      <Route path="/artists" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "pm", "art_director", "crm_manager"]}><ArtistsPage /></ProtectedRoute>} />
      <Route path="/candidates" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "pm", "art_director", "team", "sales", "sales_director"]}><CandidatesPage /></ProtectedRoute>} />
      <Route path="/candidates/:id" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "pm", "art_director", "team", "sales", "sales_director"]}><CandidateDetailPage /></ProtectedRoute>} />
      <Route path="/staff" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "finance"]}><StaffPage /></ProtectedRoute>} />
      <Route path="/org-structure" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "finance"]}><OrgStructurePage /></ProtectedRoute>} />
      <Route path="/team-utilization" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "finance"]}><TeamUtilizationPage /></ProtectedRoute>} />
      <Route path="/staff/bonus-matrix" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "finance"]}><BonusMatrixPage /></ProtectedRoute>} />
      {/* Shared absence calendar — every on-payroll role reads it (you can't
          plan work around a vacation you can't see); approve/mark actions stay
          gated to admin/pm_lead inside the page. backlog 46bb95e0 */}
      <Route path="/team-calendar" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "pm", "finance", "team", "sales", "sales_director", "crm_manager", "art_director"]}><TeamCalendarPage /></ProtectedRoute>} />
      <Route path="/team-expenses" element={<ProtectedRoute allowedRoles={["admin", "finance", "pm_lead"]}><TeamExpensesPage /></ProtectedRoute>} />
      <Route path="/other-expenses" element={<ProtectedRoute allowedRoles={["admin", "finance", "pm_lead"]}><OtherExpensesPage /></ProtectedRoute>} />
      <Route path="/pnl-forecast" element={<ProtectedRoute allowedRoles={["admin"]}><PNLForecastPage /></ProtectedRoute>} />
      <Route path="/staff-pnl" element={<ProtectedRoute allowedRoles={["admin", "finance"]}><StaffPnlDetailPage /></ProtectedRoute>} />
      <Route path="/artist-pnl" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "finance"]}><ArtistPnlPage /></ProtectedRoute>} />
      
      {/* Admin, finance and pm_lead - Artist Payments */}
      <Route path="/payments" element={<ProtectedRoute allowedRoles={["admin", "finance", "pm_lead", "pm"]}><PaymentsPage /></ProtectedRoute>} />
      <Route path="/payments/:expenseId" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "pm"]}><ArtistPaymentDetailPage /></ProtectedRoute>} />
      <Route path="/task-payments/:paymentId" element={<ProtectedRoute allowedRoles={["admin"]}><TaskPaymentDetailPage /></ProtectedRoute>} />
      
      {/* Waiting Management */}
      <Route path="/waiting-management" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "pm", "crm_manager"]}><WaitingManagementPage /></ProtectedRoute>} />
      
      {/* Settings - admin and pm_lead */}
      <Route path="/settings/services" element={<ProtectedRoute allowedRoles={["admin", "team", "pm_lead", "sales_director", "art_director"]}><ServicesManagementPage /></ProtectedRoute>} />
      <Route path="/settings/timelines" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "art_director"]}><TimelineSettingsPage /></ProtectedRoute>} />
      <Route path="/settings/statuses" element={<ProtectedRoute allowedRoles={["admin", "pm_lead"]}><StatusSettingsPage /></ProtectedRoute>} />
      <Route path="/settings/fops" element={<ProtectedRoute allowedRoles={["admin"]}><FopSettingsPage /></ProtectedRoute>} />
      <Route path="/settings/support-tariffs" element={<ProtectedRoute allowedRoles={["admin", "crm_manager", "finance", "pm_lead"]}><SupportTariffsPage /></ProtectedRoute>} />
      <Route path="/settings/payment-penalty" element={<ProtectedRoute allowedRoles={["admin", "sales_director", "pm_lead", "crm_manager", "finance"]}><PaymentPenaltySettingsPage /></ProtectedRoute>} />
      <Route path="/settings/invoice-description" element={<ProtectedRoute allowedRoles={["admin", "finance", "sales_director", "pm_lead", "crm_manager"]}><InvoiceDescriptionSettingsPage /></ProtectedRoute>} />
      <Route path="/settings/loaded-cost" element={<ProtectedRoute allowedRoles={["admin", "sales_director", "pm_lead", "finance"]}><LoadedCostSettingsPage /></ProtectedRoute>} />
      <Route path="/settings/notifications" element={<ProtectedRoute><NotificationSettingsPage /></ProtectedRoute>} />
      <Route path="/settings/orphaned-projects" element={<ProtectedRoute allowedRoles={["admin"]}><OrphanedProjectsPage /></ProtectedRoute>} />
      <Route path="/settings/integrations" element={<ProtectedRoute allowedRoles={["admin"]}><IntegrationSettingsPage /></ProtectedRoute>} />
      <Route path="/settings/wepster" element={<ProtectedRoute allowedRoles={["admin", "sales_director"]}><WepsterSettingsPage /></ProtectedRoute>} />
      <Route path="/settings/telegram" element={<ProtectedRoute allowedRoles={["admin"]}><TelegramSettingsPage /></ProtectedRoute>} />
      <Route path="/telegram" element={<ProtectedRoute allowedRoles={["admin", "sales", "sales_director", "crm_manager", "pm_lead", "pm"]}><TelegramInboxPage /></ProtectedRoute>} />
      <Route path="/settings/worksection/users" element={<ProtectedRoute allowedRoles={["admin", "pm_lead"]}><WorksectionUsersPage /></ProtectedRoute>} />
      <Route path="/settings/ai-qc" element={<ProtectedRoute allowedRoles={["admin", "art_director"]}><AIQualityControlPage /></ProtectedRoute>} />
      <Route path="/settings/support-chats" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "pm", "developer"]}><SupportChatsPage /></ProtectedRoute>} />
      <Route path="/settings/errors" element={<ProtectedRoute allowedRoles={["admin"]}><ErrorLogsPage /></ProtectedRoute>} />
      <Route path="/settings/setup-flows" element={<ProtectedRoute allowedRoles={["admin", "sales_director", "pm_lead"]}><SetupFlowsAdminPage /></ProtectedRoute>} />
      <Route path="/settings/support-kb" element={<ProtectedRoute allowedRoles={["admin"]}><SupportKbPage /></ProtectedRoute>} />
      <Route path="/settings/support-products" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "pm", "developer"]}><SupportProductsPage /></ProtectedRoute>} />
      <Route path="/settings/support-products/:slug" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "pm", "developer"]}><SupportProductDetailPage /></ProtectedRoute>} />
      <Route path="/settings/support-access" element={<ProtectedRoute allowedRoles={["admin"]}><SupportAccessPage /></ProtectedRoute>} />
      {/* Partner-facing self-service feedback queue */}
      <Route path="/my-feedback" element={<ProtectedRoute allowedRoles={["partner", "admin", "pm_lead", "pm", "team", "sales", "art_director"]}><MyFeedbackPage /></ProtectedRoute>} />
      {/* /partner-feedback kept for old bookmarks/links — renders same DevBacklogPage */}
      <Route path="/partner-feedback" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "pm", "developer"]}><DevBacklogPage /></ProtectedRoute>} />
      <Route path="/dev-backlog" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "pm", "developer"]}><DevBacklogPage /></ProtectedRoute>} />
      <Route path="/changelog" element={<ProtectedRoute allowedRoles={["admin"]}><ChangelogPage /></ProtectedRoute>} />

      {/* CRM (HubSpot mirror) — admin + sales + sales_director + crm_manager + pm_lead */}
      <Route path="/roleplay" element={<ProtectedRoute allowedRoles={["admin", "sales", "sales_director", "crm_manager", "pm_lead", "roleplay_tester"]} accessCheckUrl="/roleplay/access"><RoleplayPage /></ProtectedRoute>} />
      <Route path="/call-reviews" element={<ProtectedRoute allowedRoles={["admin", "sales", "sales_director", "crm_manager", "pm_lead"]}><CallReviewsPage /></ProtectedRoute>} />
      <Route path="/sales-leads" element={<ProtectedRoute allowedRoles={["admin", "sales_director", "crm_manager", "pm_lead"]}><SalesLeadsPage /></ProtectedRoute>} />
      <Route path="/sales-proposals" element={<ProtectedRoute allowedRoles={["admin", "sales_director", "crm_manager", "pm_lead"]}><SalesProposalsPage /></ProtectedRoute>} />
      <Route path="/social-leads" element={<ProtectedRoute allowedRoles={["admin", "sales_director", "crm_manager", "pm_lead"]}><SocialLeadsPage /></ProtectedRoute>} />
      <Route path="/marketing-analytics" element={<ProtectedRoute allowedRoles={["admin", "sales_director", "crm_manager", "sales", "pm_lead"]} accessCheckUrl="/marketing-analytics/access"><MarketingAnalyticsPage /></ProtectedRoute>} />
      <Route path="/marketing-analytics/campaign/:campaign" element={<ProtectedRoute allowedRoles={["admin", "sales_director", "crm_manager", "sales", "pm_lead"]} accessCheckUrl="/marketing-analytics/access"><MarketingCampaignReportPage /></ProtectedRoute>} />
      <Route path="/marketing-analytics/people" element={<ProtectedRoute allowedRoles={["admin", "sales_director", "crm_manager", "sales", "pm_lead"]} accessCheckUrl="/marketing-analytics/access"><MarketingPeoplePage /></ProtectedRoute>} />
      <Route path="/marketing-analytics/people/:owner_id" element={<ProtectedRoute allowedRoles={["admin", "sales_director", "crm_manager", "sales", "pm_lead"]} accessCheckUrl="/marketing-analytics/access"><MarketingPersonProfilePage /></ProtectedRoute>} />
      <Route path="/marketing-analytics/sales" element={<ProtectedRoute allowedRoles={["admin", "sales_director", "crm_manager", "sales", "pm_lead"]} accessCheckUrl="/marketing-analytics/access"><MarketingSalesPage /></ProtectedRoute>} />
      <Route path="/marketing-analytics/landings" element={<ProtectedRoute allowedRoles={["admin", "sales_director", "crm_manager", "sales", "pm_lead"]} accessCheckUrl="/marketing-analytics/access"><MarketingLandingsPage /></ProtectedRoute>} />
      <Route path="/marketing-analytics/chats" element={<ProtectedRoute allowedRoles={["admin", "sales_director", "crm_manager", "sales", "pm_lead"]} accessCheckUrl="/marketing-analytics/access"><MarketingChatsPage /></ProtectedRoute>} />
      {/* Ads Quality — spend ⨝ lead quality (project size). No `sales`: shows lead company names. */}
      <Route path="/ads-quality" element={<ProtectedRoute allowedRoles={["admin", "sales_director", "crm_manager", "pm_lead"]}><AdsQualityPage /></ProtectedRoute>} />

      {/* Artist pages */}
      <Route path="/artist-dashboard" element={<ProtectedRoute allowedRoles={["artist"]}><ArtistDashboardPage /></ProtectedRoute>} />
      <Route path="/artist-contract" element={<ProtectedRoute allowedRoles={["artist"]}><ArtistContractPage /></ProtectedRoute>} />
      <Route path="/artist-tasks" element={<ProtectedRoute allowedRoles={["artist"]}><ArtistTasksPage /></ProtectedRoute>} />
      
      {/* Art Director pages */}
      <Route path="/service-rates" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "art_director", "finance"]}><ServiceRatesPage /></ProtectedRoute>} />
      
      {/* Client pages */}
      <Route path="/client" element={<ProtectedRoute allowedRoles={["client"]}><ClientPortalPage /></ProtectedRoute>} />
      <Route path="/client-portal" element={<ProtectedRoute allowedRoles={["client"]}><ClientPortalPage /></ProtectedRoute>} />
      {/* Read-only "view as client" mirror for internal users (gated inside the wrapper) */}
      <Route path="/client-preview" element={<ClientCabinetPreview />} />
      <Route path="/client/projects" element={<ProtectedRoute allowedRoles={["client"]}><ClientProjectsPage /></ProtectedRoute>} />
      <Route path="/client/projects/:projectId" element={<ProtectedRoute allowedRoles={["client"]}><ClientProjectDetailPage /></ProtectedRoute>} />
      <Route path="/client/tasks" element={<ProtectedRoute allowedRoles={["client"]}><ClientTasksView /></ProtectedRoute>} />
      <Route path="/client/tasks/:id" element={<ProtectedRoute allowedRoles={["client"]}><TaskDetailPage /></ProtectedRoute>} />
      <Route path="/client/requests" element={<ProtectedRoute allowedRoles={["client"]}><ClientMyRequestsPage /></ProtectedRoute>} />
      <Route path="/client/payments" element={<ProtectedRoute allowedRoles={["client"]}><ClientPaymentsView /></ProtectedRoute>} />
      <Route path="/client-requests" element={<ProtectedRoute allowedRoles={["admin", "pm", "pm_lead"]}><ClientRequestsPage /></ProtectedRoute>} />
      <Route path="/client-requests/:id" element={<ProtectedRoute allowedRoles={["admin", "pm", "pm_lead", "partner", "client"]}><ClientRequestDetailPage /></ProtectedRoute>} />
      
      {/* Project Timeline - visual workflow for clients */}
      <Route path="/project-timeline/:projectId" element={<ProtectedRoute><ProjectTimelinePage /></ProtectedRoute>} />
      <Route path="/project-timeline" element={<ProtectedRoute><ProjectTimelinePage /></ProtectedRoute>} />
      
      {/* Notifications - all users */}
      <Route path="/notifications" element={<ProtectedRoute><NotificationsPage /></ProtectedRoute>} />
      
      {/* Sales pages - admin, sales, sales_director */}
      <Route path="/sales" element={<ProtectedRoute allowedRoles={["admin", "sales", "sales_director", "pm_lead"]}><SalesDashboardPage /></ProtectedRoute>} />
      <Route path="/pm-bonuses" element={<ProtectedRoute allowedRoles={["admin", "pm_lead", "pm"]}><PMBonusesPage /></ProtectedRoute>} />
      <Route path="/sales/project/:projectId" element={<ProtectedRoute allowedRoles={["admin", "sales", "sales_director", "pm_lead", "pm"]}><SalesProjectEditPage /></ProtectedRoute>} />
      <Route path="/sales/payment/:paymentId" element={<ProtectedRoute allowedRoles={["admin", "sales", "sales_director", "pm_lead"]}><PaymentDetailPage /></ProtectedRoute>} />
      
      {/* Sales PnL - admin and sales_director (Commercial Director) only */}
      <Route path="/sales-pnl" element={<ProtectedRoute allowedRoles={["admin", "sales_director"]}><SalesPnlPageNew /></ProtectedRoute>} />
      
      {/* CRM Income - admin only */}
      <Route path="/crm-income" element={<ProtectedRoute allowedRoles={["admin", "crm_manager", "pm_lead"]}><CrmIncomePage category="crm" /></ProtectedRoute>} />
      <Route path="/support-payments" element={<ProtectedRoute allowedRoles={["admin", "crm_manager", "pm_lead"]}><CrmIncomePage category="support" /></ProtectedRoute>} />
      <Route path="/crm-pnl" element={<ProtectedRoute allowedRoles={["admin", "crm_manager"]}><CrmPnlPage /></ProtectedRoute>} />
      <Route path="/crm-dashboard" element={<ProtectedRoute allowedRoles={["admin", "crm_manager"]}><CrmDashboardPage /></ProtectedRoute>} />
      
      {/* General PnL - admin only */}
      <Route path="/general-pnl" element={<ProtectedRoute allowedRoles={["admin"]}><GeneralPnlPage /></ProtectedRoute>} />
      <Route path="/roadmap" element={<ProtectedRoute allowedRoles={["admin", "sales_director", "pm_lead", "team"]}><RoadmapPage /></ProtectedRoute>} />
      <Route path="/income" element={<ProtectedRoute allowedRoles={["admin", "crm_manager", "finance", "pm_lead"]}><IncomePage /></ProtectedRoute>} />
      
      {/* TRP Projects - admin and partners */}
      {/* Old /trp route - redirect partners to /trp/sales, admins see old page */}
      <Route path="/trp" element={
        <ProtectedRoute allowedRoles={["admin", "partner"]}>
          <TrpRedirectWrapper />
        </ProtectedRoute>
      } />
      <Route path="/trp/sales" element={<ProtectedRoute allowedRoles={["admin", "partner", "pm_lead"]}><TrpSalesPage /></ProtectedRoute>} />
      <Route path="/trp/project/:projectId" element={<ProtectedRoute allowedRoles={["admin", "partner"]}><PartnerProjectPage /></ProtectedRoute>} />
      <Route path="/trp/project/:projectId/payment/:paymentIndex" element={<ProtectedRoute allowedRoles={["admin", "partner"]}><TrpPaymentDetailPage /></ProtectedRoute>} />
      <Route path="/trp/tasks" element={<ProtectedRoute allowedRoles={["admin", "partner"]}><PartnerTasksPage /></ProtectedRoute>} />
      <Route path="/trp/requests" element={<ProtectedRoute allowedRoles={["admin", "partner"]}><PartnerRequestsPage /></ProtectedRoute>} />
      <Route path="/trp/payments" element={<ProtectedRoute allowedRoles={["admin", "partner"]}><MyPaymentSchedulePage /></ProtectedRoute>} />
      <Route path="/trp/artists" element={<ProtectedRoute allowedRoles={["admin", "partner"]}><PartnerArtistsPage /></ProtectedRoute>} />
      
      {/* Profile - all users */}
      <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
      
      {/* My Payments - all users (default for non-admin) */}
      <Route path="/my-payments" element={<ProtectedRoute><MySalaryPage /></ProtectedRoute>} />
      <Route path="/my-tasks" element={<ProtectedRoute><MyTasksPage /></ProtectedRoute>} />
      
      {/* My Expenses - employees can submit expense requests */}
      <Route path="/my-expenses" element={<ProtectedRoute><MyExpensesPage /></ProtectedRoute>} />
      
      {/* Admin Security & Backup */}
      <Route path="/admin/security" element={<ProtectedRoute allowedRoles={["admin"]}><AdminSecurityPage /></ProtectedRoute>} />
      
      {/* Sandbox / OpenClaw */}
      <Route path="/sandbox" element={<ProtectedRoute allowedRoles={["admin", "pm_lead"]}><SandboxPage /></ProtectedRoute>} />

      {/* Partner revenue projection calculator (0–12 months, optimistic/pessimistic) */}
      <Route path="/partner-calculator" element={<ProtectedRoute allowedRoles={["admin", "sales_director", "pm_lead", "finance"]}><PartnerRevenueCalculatorPage /></ProtectedRoute>} />

      
      {/* Default redirect based on role */}
      <Route path="*" element={<Navigate to={user ? defaultRoute : "/"} replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CurrencyProvider>
          <AppRoutes />
          <SupportChat />
          <BacklogReviewPopup />
          <AppUpdateNotice />
          <Toaster position="top-right" richColors />
        </CurrencyProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
